import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    url: String,
    name: String,
    properties: Object,
  };

  createAhoyEvent(event) {
    const properties = this.propertiesValue;
    const email = event.target.value;

    if (email !== '' && email !== undefined) {
      properties.email = email;
    }

    const params = JSON.stringify({
      ahoy_event: { name: this.nameValue, properties: properties },
    });

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': Rails.csrfToken(),
      },
      body: params,
    });
  }
}
